import React from 'react';
import { Option } from '../Option/Option';
import { CatcherThrowsOptionWrapper } from './CatcherThrowsOptionStyles';

interface IProps {
  onPressHotkeyCallback: (value: React.ReactText) => void;
  onClickCallback: (value: React.ReactText) => void;
  hotkeyCode: number;
  hotkeyDisplay: string;
  value: string;
  displayName: string;
  className?: string;
  disabled?: boolean;
}

export const CatcherThrowsOption: React.FC<IProps> = ({
  onPressHotkeyCallback,
  onClickCallback,
  hotkeyCode,
  hotkeyDisplay,
  value,
  displayName,
  className,
  disabled,
}) => {
  return (
    <CatcherThrowsOptionWrapper className={`catcher-throws-option ${className} ${disabled ? ' disabled' : ''}`}>
      <Option
        displayName={displayName}
        hotkeyCode={hotkeyCode}
        hotkeyDisplay={hotkeyDisplay}
        value={value}
        onPressHotkeyCallback={onPressHotkeyCallback}
        onClickCallBack={onClickCallback}
        data-testid={className}
      />
    </CatcherThrowsOptionWrapper>
  );
};
